import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGG_FAILED_TRIPS_LEGEND_7DAYS } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';

const aggFailedTripsLegendComponent7days = () => (
    <div>
        <LegendRenderer config={AGG_FAILED_TRIPS_LEGEND_7DAYS} />
        <div className={styles.legendDescriptionWrapper}>
            <span className={styles.legendDescription}>
                {t`Неудачные старты по причине выпадения самокатов в Offline`}
            </span>
        </div>
    </div>
);

export const AggFailedTripsLegend = withDisplayedLayersCheck(
    aggFailedTripsLegendComponent7days,
    t`Неудачные старты (7 дней)`
);
